import { CloseIcon } from 'assets/icons/CloseIcon'
import CalendarInput from 'components/CalendarInput/CalendarInput'
import { Input } from 'components/Input/Input'
import { Modal } from 'components/Modal/Modal'
import { extendStay } from 'features/accommodation/accommodationSlice'
import useModalClose from 'hooks/useModalClose'
import { useState } from 'react'
import { useDispatch } from 'react-redux'
import { AppDispatch } from 'store'
import { Button, CursorPointer, Flex } from 'styling/GlobalStyles'
import { TitleText } from 'styling/Typography'
import useFocusFirstInput from 'utils/useFocusFirstInput'

export const ExtendStayModal = ({ closeModal, id }: { closeModal: any, id?: number }) => {
    const [state, setState] = useState({
        expectedCheckOutTimestamp: null,
        overrideReason: null
    })
    const dispatch = useDispatch<AppDispatch>()
    useFocusFirstInput()
    useModalClose(closeModal)

    console.log(id)

    const handleChange = (e: React.ChangeEvent<HTMLInputElement>, name: string) => {
        setState({ ...state, [name]: e.target.value })
    }

    const handleSave = async () => {
        const resp = await dispatch(extendStay({ ...state, id }))
        if (resp.meta.requestStatus === 'fulfilled') {
            closeModal()
        }
    }


    return <Modal black>
        <Flex column between center >
            <Flex column gap='1rem' width='100%' >
                <Flex between width='100%' center style={{ marginBottom: '1rem' }}>
                    <TitleText weight='bold' > Extend Stay</TitleText>
                    <CursorPointer onClick={closeModal} >
                        <CloseIcon />
                    </CursorPointer>
                </Flex>
                <Flex gap='1rem' column >
                    <CalendarInput onChange={date => setState(prev => ({ ...prev, expectedCheckOutTimestamp: date }))} labelText='Expected Check-Out' defaultValue={state.expectedCheckOutTimestamp} />
                    <Input height='150px' type='textarea' placeholder='Enter override reason...' labelText='Override Reason' value={state.overrideReason} onChange={e => handleChange(e, 'overrideReason')} nomarg />
                </Flex>
            </Flex>
            <Button mt='16' disabled={!state.expectedCheckOutTimestamp || !state.overrideReason} orange onClick={handleSave} >Save</Button>
        </Flex>
    </Modal>
}

